/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button, CircularProgress, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { useQueryString, useResponseUser, useTest } from '@orientaction/hooks';
import { LayoutResultat } from '@orientaction/layouts';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useStyles } from './style';

const NoResponsePage = () => {
  const classes = useStyles();

  const history = useHistory();

  const queryString = useQueryString();

  return (
    <LayoutResultat showBottomLines={false} showToplines={false} isV2={true} usefullHeight={true}>
      <>
        <div className={classes.flexCenter}>
          <Grid container={true} direction="column" justifyContent="center" alignItems="center">
            <Grid item={true} xs={12} container={true} style={{ width: '100%' }}>
              <div className={classes.text}>
                Vous n'avez selectionné aucune réponse lors de ce test : Aucun résultat ne peut être
                affiché
              </div>
            </Grid>

            <Grid item={true} xs={12} style={{ width: '100%' }}>
              <Button
                variant="outlined"
                className={classes.buttonGoTo}
                onClick={() => history.push(`/${queryString.get('redirect')}`)}>
                Recommencer le test
              </Button>
            </Grid>
          </Grid>
        </div>
      </>
    </LayoutResultat>
  );
};
export default NoResponsePage;
